// Debug utilities for development and testing
// This will be enabled once prod testing is done

/**
 * Check if debug mode is enabled via URL parameter
 * @returns {boolean} True if debug mode is enabled
 */
export const isDebugModeEnabled = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('enableDebugging') === '1';
};

/**
 * Get debug mode state for components
 * @returns {object} Debug state object
 */
export const getDebugState = () => {
  const isEnabled = isDebugModeEnabled();
  
  return {
    isEnabled,
    showDebugButton: isEnabled,
    showPartnerButton: isEnabled, // For "Become Trusted Partner" button visibility
  };
};

/**
 * Clear all dashboard data (debug function)
 */
export const clearDashboardData = () => {
  if (!isDebugModeEnabled()) return;
  
  console.log('Debug: Clearing dashboard data');
  
  // Clear localStorage items
  const itemsToClear = [
    'ndaAgreed',
    'ndaAgreementDate',
    'partnershipAgreed', 
    'partnershipAgreementDate',
    'shariyahCompleted',
    'shariyahCompletionDate',
    'legalCompleted',
    'legalCompletionDate',
    'techSetupCompleted',
    'techSetupCompletionDate',
    'trainingCompleted',
    'trainingCompletionDate',
    'launchCompleted',
    'launchCompletionDate',
    'techSetupProgress',
    'trainingProgress',
    'launchProgress',
    'partnerType',
    'uploadedFiles',
    'legalUploadedFiles'
  ];
  
  itemsToClear.forEach(item => {
    localStorage.removeItem(item);
  });
  
  console.log('Debug: Dashboard data cleared');
};

/**
 * Log debug message if debug mode is enabled
 * @param {string} message - Debug message to log
 */
export const debugLog = (message) => {
  if (isDebugModeEnabled()) {
    console.log(`Debug: ${message}`);
  }
}; 